export default {
  'rpaAgent.section.agent': 'Agente lógico',
  'rpaAgent.section.session': 'Sesión vigente',
  'rpaAgent.section.installation': 'Equipo vinculado',
  'rpaAgent.section.flows': 'Flujos',

  'rpaAgent.field.sessionSequence': 'Secuencia',
  'rpaAgent.field.startedAt': 'Inicio del vínculo',
  'rpaAgent.field.endedAt': 'Fin del vínculo',
  'rpaAgent.field.endReason': 'Motivo de cierre',
  'rpaAgent.field.deviceName': 'Equipo',
  'rpaAgent.field.lastIp': 'Última IP',
  'rpaAgent.field.firstSeenAt': 'Primera conexión',
  'rpaAgent.field.lastSeenAt': 'Última conexión',
  'rpaAgent.field.hardwareId': 'Identificador de hardware',
  'rpaAgent.field.installationActive': 'Instalación activa',

  'rpaAgent.empty.unlinked': 'Este agente todavía no se ha vinculado con un equipo.',
  'rpaAgent.empty.unlinkedWithHistory':
    'Actualmente no hay un equipo vinculado. Consulta el historial para ver vínculos anteriores.',
  'rpaAgent.empty.created':
    'El vínculo fue creado y está esperando la primera conexión del equipo.',
  'rpaAgent.empty.flows': 'Este agente todavía no tiene flujos.',
  'rpaAgent.empty.sessions': 'No hay sesiones para mostrar.',
  'rpaAgent.empty.sessionsMore': 'No hay más sesiones para mostrar.',

  'rpaAgent.action.history': 'Historial de equipos',
  'rpaAgent.action.unlink': 'Desvincular equipo',
  'rpaAgent.action.unlink.confirmTitle': 'Desvincular equipo',
  'rpaAgent.action.unlink.confirm':
    'El agente dejará de recibir nuevas ejecuciones en este equipo. Las ejecuciones que ya obtuvieron un lease de inicio pueden finalizar. El historial se conservará.',
  'rpaAgent.action.deactivate': 'Desactivar',
  'rpaAgent.action.deactivate.confirm':
    'El agente dejará de aceptar nuevas operaciones. ¿Deseas continuar?',
  'rpaAgent.action.rename': 'Renombrar',
  'rpaAgent.action.copyHardware': 'Copiar identificador',
  'rpaAgent.action.copied': 'Identificador copiado',
  'rpaAgent.action.loadMore': 'Cargar más',
  'rpaAgent.action.viewHistory': 'Ver historial de equipos',

  'rpaAgent.sessions.title': 'Historial de equipos',
  'rpaAgent.sessions.description': 'Vínculos anteriores y vigentes de este agente RPA.',
  'rpaAgent.sessions.current': 'Vigente',
  'rpaAgent.sessions.ended': 'Finalizada',
  'rpaAgent.sessions.loading': 'Cargando historial…',
  'rpaAgent.sessions.devicePending': 'Equipo pendiente',
  'rpaAgent.sessions.deviceUnknown': 'Equipo desconocido',
  'rpaAgent.sessions.waitingDevice': 'Esperando la primera conexión del equipo',

  'rpaAgent.summary.flows': '{count, plural, one {# flujo} other {# flujos}}',
  'rpaAgent.summary.published': '{count} publicadas',
  'rpaAgent.summary.drafts': '{count} borradores',
  'rpaAgent.flow.draft': ' · borrador',
  'rpaAgent.summary.todayExecutions': '{count} ejecuciones hoy',
  'rpaAgent.summary.recentErrors': '{count} errores recientes',

  'agents.rpa.sessionStatus.created': 'Pendiente de conexión',
  'agents.rpa.sessionStatus.online': 'En línea',
  'agents.rpa.sessionStatus.offline': 'Sin conexión',
  'agents.rpa.sessionStatus.replaced': 'Reemplazada',
  'agents.rpa.sessionStatus.revoked': 'Desvinculada',

  'launchpad.actions.add.rpa': 'Agregar agente RPA',
  'launchpad.kebab.unlinkDevice': 'Desvincular equipo',
  'launchpad.kebab.deviceHistory': 'Historial de equipos',
};
